import { motion } from "framer-motion";

const items = [
  "Vertraulich",
  "Urteilsfrei",
  "Suchtprävention",
  "Online & persönlich",
  "Auf Augenhöhe",
  "Dein Tempo",
  "Verschwiegenheit",
  "Lünen",
];

export default function Marquee({ variant = "light" }) {
  const row = [...items, ...items];
  const isDark = variant === "dark";
  return (
    <section
      aria-hidden
      className={`relative overflow-hidden py-8 border-y ${
        isDark ? "bg-[#45281A] border-white/5" : "bg-[#FCEFE2] border-black/5"
      }`}
    >
      <motion.div
        className="flex whitespace-nowrap gap-14"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ repeat: Infinity, ease: "linear", duration: 55 }}
      >
        {row.map((it, i) => (
          <span
            key={`${it}-${i}`}
            className={`font-serif italic text-3xl sm:text-4xl md:text-5xl tracking-tight ${
              isDark ? "text-[#FCEFE2]" : "text-[#2E1A10]"
            }`}
          >
            {it}
            <span className="text-[#D9966F] not-italic mx-10">✦</span>
          </span>
        ))}
      </motion.div>
    </section>
  );
}
